'use client';

import {useEffect, useRef, useState} from 'react';

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useAppActivation(callback?: () => void) {
  const savedCallback = useRef(callback);
  const [active, setActive] = useState(true);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function handleAppActivation() {
      if (document.visibilityState === 'visible') {
        savedCallback.current?.();
      }
      setActive(document.visibilityState === 'visible');
    }

    window.addEventListener('visibilitychange', handleAppActivation);

    return () => {
      window.removeEventListener('visibilitychange', handleAppActivation);
    };
  }, []);

  return active;
}
